




/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const CREATEFEED= createAsyncThunk(
  "createFeed/createFeed",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const createFeedSlice = createSlice({
  name: "createFeedSlice",
  initialState: {
    createFeed: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfcreateFeed: (state) => {
        state.createFeed.loading = false
        state.createFeed.error = false
        state.createFeed.data = []
        state.createFeed.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(CREATEFEED.fulfilled, (state, action) => {
      state.createFeed = {
        ...state.createFeed,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CREATEFEED.pending, (state, action) => {
      state.createFeed = {
        ...state.createFeed,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(CREATEFEED.rejected, (state, action) => {
      state.createFeed = {
        ...state.createFeed,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const createFeedAction = {
    CREATEFEED,
};

export { createFeedAction };
export default createFeedSlice.reducer;
export const {setInitialStateOfcreateFeed} = createFeedSlice.actions
